import moment from "moment";

// The product table's upcoming days (target-only columns, left of TODAY).
// They are hidden until someone opens them, so every table starts at TODAY;
// a handle on the table's left edge and a link in the velocity summary show
// and hide them.

// Width of the "Next N days" handle, and of the pinned spacer column it sits
// on (so it never covers TODAY).
export const UPCOMING_TAB_WIDTH = 22;

// Field of that spacer column.
export const UPCOMING_HANDLE_FIELD = "upcoming-handle";

// The handle pulses until someone opens the upcoming days once, and only while
// the feature is new. After this date it stays as a plain handle.
const UPCOMING_CUE_PULSE_UNTIL = "2027-01-31";

const SEEN_KEY = "velocity.upcomingDaysSeen";
const SEEN_EVENT = "velocity:upcoming-days-seen";

// Sum of the adjusted daily targets over the upcoming dates ("MM-DD"), across
// the ASINs of a row. Mirrors how the table's target row adds them up.
export const sumUpcomingTargets = (predictedUnitsByAsin, upcomingDates) => {
  const wanted = new Set(upcomingDates || []);
  if (wanted.size === 0) return 0;
  let total = 0;
  Object.values(predictedUnitsByAsin || {}).forEach((entry) => {
    if (!entry || !Array.isArray(entry.dates)) return;
    entry.dates.forEach((date, i) => {
      if (wanted.has(date.slice(-5))) total += entry.adj_target?.[i] ?? 0;
    });
  });
  return Math.round(total);
};

export const hasSeenUpcomingDays = () => {
  try {
    return window.localStorage.getItem(SEEN_KEY) === "1";
  } catch {
    return false;
  }
};

export const markUpcomingDaysSeen = () => {
  try {
    window.localStorage.setItem(SEEN_KEY, "1");
  } catch {
    // Storage unavailable: only this page's handles stop pulsing.
  }
  // Every row's handle stops pulsing, not just the one that was clicked.
  window.dispatchEvent(new Event(SEEN_EVENT));
};

// Subscribe to "seen" from any row; returns the unsubscribe function.
export const onUpcomingDaysSeen = (handler) => {
  window.addEventListener(SEEN_EVENT, handler);
  return () => window.removeEventListener(SEEN_EVENT, handler);
};

export const shouldPulse = (seen, now = moment()) =>
  !seen && moment(now).isSameOrBefore(UPCOMING_CUE_PULSE_UNTIL, "day");
